// AgoraProvider.jsx
import React from "react";
import AgoraRTC from "agora-rtc-sdk-ng";
import { AgoraRTCProvider } from "agora-rtc-react";

const rtcClient = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

const AgoraProvider = ({ children }) => {
  return (
    <AgoraRTCProvider client={rtcClient}>
      {children}
    </AgoraRTCProvider>
  );
};

export default AgoraProvider;
